import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import { withRouter } from "react-router-dom";
import { login } from "actions/login";

const mapDispatchToProps = {
  login
};

class Login extends React.Component {
  state = {
    login: {
      email: "",
      password: ""
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    const { history } = this.props;
    this.props.login(this.state.login).then(() => history.push("/admin"));
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  render() {
    return (
      <form
        onSubmit={this.handleSubmit}
        className="form-horizontal"
        method="POST"
        action="/login"
      >
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6">
            <h2>Logg inn</h2>
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6">
            <div className="form-group has-danger">
              <label className="sr-only" htmlFor="email">
                E-Mail Address
              </label>
              <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <div className="input-group-addon" style={{ width: "2.6rem" }}>
                  <i className="fa fa-at" />
                </div>
                <input
                  type="text"
                  name="email"
                  className="form-control"
                  id="email"
                  placeholder="you@example.com"
                  onChange={e =>
                    this.handleChange(["login", "email"], e.target.value)
                  }
                  value={this.state.login.email}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6">
            <div className="form-group">
              <label className="sr-only" htmlFor="password">
                Password
              </label>
              <div className="input-group mb-2 mr-sm-2 mb-sm-0">
                <div className="input-group-addon" style={{ width: "2.6rem" }}>
                  <i className="fa fa-key" />
                </div>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  id="password"
                  placeholder="Password"
                  onChange={e =>
                    this.handleChange(["login", "password"], e.target.value)
                  }
                  value={this.state.login.password}
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3" />
          <div className="col-md-6" style={{ paddingLeft: "57px" }}>
            <button type="submit" className="btn btn-success">
              <i className="fa fa-sign-in" /> Logg inn
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default R.compose(withRouter, connect(null, mapDispatchToProps))(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js